import { websiteEnv } from '@/constants/website-env';
import Cookies from 'js-cookie';

export const getCookieStoreCode = () => {
  if (websiteEnv.isSpain) {
    return parseCookieStoreCode(Cookies.get('es_store'));
  }

  if (websiteEnv.isGermany) {
    return parseCookieStoreCode(Cookies.get('de_store'));
  }

  if (websiteEnv.isNetherlands) {
    return parseCookieStoreCode(Cookies.get('nl_store'));
  }

  return null;
};

export const removeCookieStoreCode = () => {
  if (websiteEnv.isSpain) {
    Cookies.remove('es_store');
    return;
  }

  if (websiteEnv.isGermany) {
    Cookies.remove('de_store');
    return;
  }

  if (websiteEnv.isNetherlands) {
    Cookies.remove('nl_store');
    return;
  }
};

export const setCookieStoreCode = storeCode => {
  if (websiteEnv.isSpain) {
    Cookies.set('es_store', storeCode, { path: '/', expires: 365 });
    return;
  }

  if (websiteEnv.isGermany) {
    Cookies.set('de_store', storeCode, { path: '/', expires: 365 });
    return;
  }

  if (websiteEnv.isNetherlands) {
    Cookies.set('nl_store', storeCode, { path: '/', expires: 365 });
    return;
  }
};

export const parseCookieStoreCode = (cookieStoreCode: string | null | undefined) => {
  if (websiteEnv.isSpain) {
    if (!cookieStoreCode) return 'es';

    if (cookieStoreCode === 'mx') return cookieStoreCode;

    return 'es';
  }

  if (websiteEnv.isGermany) {
    if (!cookieStoreCode) return 'de';

    if (cookieStoreCode === 'at' || cookieStoreCode === 'ch') return cookieStoreCode;

    return 'de';
  }

  if (websiteEnv.isNetherlands) {
    if (!cookieStoreCode) return 'nl';

    if (cookieStoreCode === 'be') return cookieStoreCode;

    return 'nl';
  }

  return null;
};

export const getCurrencyCodeFromCookieStoreCode = (cookieStoreCode: string | null | undefined) => {
  if (websiteEnv.isSpain) {
    if (!cookieStoreCode) return 'EUR';

    if (cookieStoreCode === 'es') return 'EUR';

    if (cookieStoreCode === 'mx') return 'MXN';

    return null;
  }

  if (websiteEnv.isGermany) {
    if (!cookieStoreCode) return 'EUR';

    if (cookieStoreCode === 'de') return 'EUR';

    if (cookieStoreCode === 'at') return 'EUR';

    if (cookieStoreCode === 'ch') return 'CHF';

    return null;
  }

  if (websiteEnv.isNetherlands) {
    if (!cookieStoreCode) return 'EUR';

    if (cookieStoreCode === 'nl') return 'EUR';

    if (cookieStoreCode === 'be') return 'EUR';

    return null;
  }

  return null;
};

export const getCountryCodeFromCookieStoreCode = (cookieStoreCode: string | null | undefined) => {
  if (websiteEnv.isSpain) {
    if (!cookieStoreCode) return 'ES';

    if (cookieStoreCode === 'es') return 'ES';

    if (cookieStoreCode === 'mx') return 'MX';

    return null;
  }

  if (websiteEnv.isGermany) {
    if (!cookieStoreCode) return 'DE';

    if (cookieStoreCode === 'de') return 'DE';

    if (cookieStoreCode === 'at') return 'AT';

    if (cookieStoreCode === 'ch') return 'CH';

    return null;
  }

  if (websiteEnv.isNetherlands) {
    if (!cookieStoreCode) return 'NL';

    if (cookieStoreCode === 'nl') return 'NL';

    if (cookieStoreCode === 'be') return 'BE';

    return null;
  }

  return null;
};
